import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import createHistory from 'history/createBrowserHistory';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';
import Raven from 'raven-js';
import createRavenMiddleware from 'raven-for-redux';
import throttle from 'lodash/throttle';
import reducers from './reducers';
import { loadState, saveState } from './localStorage';

export const history = createHistory();

const routMiddleware = routerMiddleware(history);

if (process.env.REACT_APP_SENTRY_API_KEY) {
  Raven.config(
    `https://${process.env.REACT_APP_SENTRY_API_KEY}@sentry.io/${process.env.REACT_APP_SENTRY_PROJECT_ID}`,
    { environment: process.env.REACT_APP_ENV }
  ).install();
}

/* eslint-disable no-underscore-dangle */
const composeEnhancers =
  (process.env.NODE_ENV !== 'production' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;
/* eslint-enable */

const persistedState = loadState();

export const store = createStore(
  combineReducers({
    ...reducers,
    router: routerReducer
  }),
  persistedState,
  composeEnhancers(
    applyMiddleware(routMiddleware, thunk, createRavenMiddleware(Raven))
  )
);

store.subscribe(
  throttle(() => {
    const { user, utm } = store.getState().auth;
    saveState({
      auth: {
        loggedIn: !!user,
        user,
        utm
      }
    });
  }, 1000)
);



// WEBPACK FOOTER //
// ./src/store.js